module.exports = __webpack_public_path__ + "img/money.3bcbbf1a.svg";